import React from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton } from 'components/DataController/ActionButton';
import { IconName } from 'components/Icon/Icon';
import { CustomPop } from 'components/Popover/CustomPop';

interface IProps {
	onClickInfo?: () => void;
	onClickArchive?: () => void;
	onClickRestore?: () => void;
	onClickDelete?: () => void;
	onClickEdit?: () => void; // You should choose between two types of edit handlers:
	URLWithIDToEdit?: string; // by navigate to edit page URL or by callback
	URLWithIDToInfo?: string;
	isOpenInfo?: boolean;
	customEditButton?: React.ReactNode;
}

export const DataControllerNew: React.FC<IProps> = ({
	onClickInfo,
	onClickArchive,
	onClickRestore,
	onClickDelete,
	onClickEdit,
	URLWithIDToEdit,
	URLWithIDToInfo,
	isOpenInfo = false,
	customEditButton,
}) => {
	const { t } = useTranslation('listing');

	const editButton = (
		<ActionButton
			icon={IconName.edit}
			title={t('editTooltip')}
			to={URLWithIDToEdit}
			testId="DataControllerEdit"
			onClick={onClickEdit}
		/>
	);

	return (
		<div className="flex gap-2" data-test="DataController">
			{(URLWithIDToInfo || onClickInfo) && (
				<ActionButton
					icon={isOpenInfo ? IconName.chevronUp : IconName.info}
					title={t('additionalInfoTooltip')}
					to={URLWithIDToInfo}
					testId="DataControllerInfo"
					onClick={onClickInfo}
				/>
			)}
			{customEditButton ? (
				<CustomPop childrenContent={customEditButton}>{editButton}</CustomPop>
			) : (
				(URLWithIDToEdit || onClickEdit) && editButton
			)}
			{onClickArchive && (
				<ActionButton
					icon={IconName.archive}
					title={t('archiveTooltip')}
					testId="DataControllerArchive"
					onClick={onClickArchive}
				/>
			)}
			{onClickRestore && (
				<ActionButton
					icon={IconName.restore}
					title={t('restoreTooltip')}
					testId="DataControllerRestore"
					onClick={onClickRestore}
				/>
			)}
			{onClickDelete && (
				<ActionButton
					icon={IconName.delete}
					title={t('deleteTooltip')}
					testId="DataControllerDelete"
					onClick={onClickDelete}
				/>
			)}
		</div>
	);
};
